import React from "react";
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import { CategoriesImageUI } from "../CategoriesImages/CategoriesImageUI";
import { COLORS } from '../../../assets/colors';
import { NavLink } from "react-router-dom";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import IconButton from '@mui/material/IconButton';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: '400px', md: '550px', lg: '550px', xl: '550px' },
    maxHeight: '90vh',
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, rgba(30, 58, 95, 0.98) 100%)`,
    boxShadow: '0px 12px 40px rgba(0, 0, 0, 0.5)',
    padding: { xs: 3, sm: 4 },
    borderRadius: '20px',
    border: '3px solid #d7b547',
    overflow: 'auto'
};

function CategoriesModalUI({
    open,
    setOpen,
    data
}) {
    const handleClose = () => setOpen(false);
    const message = `Hola, estoy interesado/a en realizar un pedido del siguiente ponque con nombre: ${data.name} y descripción: ${data.description}. ¿Podrían por favor proporcionarme información sobre los sabores disponibles, tamaños, precios y opciones de entrega? ¡Gracias!`;
    const url = `https://api.whatsapp.com/send?phone=573128031680&text=${encodeURIComponent(message)}`;
    if (data) {
        return (
            <div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    slots={{ backdrop: Backdrop }}
                    slotProps={{
                        backdrop: {
                            timeout: 500,
                        },
                    }}
                >
                    <Fade in={open}>
                        <Box sx={style}>
                            {data.details && data.details.length > 1 && (
                                <CategoriesImageUI
                                    details={data.details}
                                />
                            )}

                            <Typography variant="h4" component="h2" sx={{
                                fontFamily: 'Quicksand',
                                fontWeight: 'bold',
                                textAlign: "center",
                                color: COLORS.secondary,
                                fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2rem' },
                                marginBottom: 2,
                                textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
                            }}>
                                {data.name}
                            </Typography>
                            <Typography variant="body1" component="p"
                                sx={{
                                    fontFamily: 'Quicksand',
                                    textAlign: "center",
                                    color: '#ffffff',
                                    fontSize: { xs: '0.95rem', sm: '1rem' },
                                    lineHeight: 1.6,
                                    marginBottom: 3,
                                    padding: { xs: '0 10px', sm: '0 20px' }
                                }}>
                                {data.description}
                            </Typography>

                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: 3
                            }}>
                                <NavLink to={url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                        background: '#25D366',
                                        color: 'white',
                                        padding: '12px 24px',
                                        borderRadius: '30px',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        boxShadow: '0 4px 12px rgba(37, 211, 102, 0.4)',
                                        '&:hover': {
                                            transform: 'translateY(-2px)',
                                            boxShadow: '0 6px 16px rgba(37, 211, 102, 0.6)',
                                        }
                                    }}>
                                        <WhatsAppIcon sx={{ fontSize: '28px' }} />
                                        <Typography sx={{
                                            fontFamily: 'Quicksand',
                                            fontWeight: 'bold',
                                            fontSize: { xs: '0.9rem', sm: '1rem' }
                                        }}>
                                            Realizar Pedido
                                        </Typography>
                                    </Box>
                                </NavLink>
                            </Box>
                        </Box>
                    </Fade>
                </Modal>
            </div>
        )
    }

}


export { CategoriesModalUI }